import React from 'react';
import Wrapper from './styles';
import { Link } from 'react-router-dom';
import heroBcg from '../../assets/hero1.jpeg';
import heroBcg2 from '../../assets/hero2.jpeg';

const Hero = () => {
  return (
    <Wrapper className='section-center'>
      <article className='content'>
        <h1>
        Welcome to <br />
        Diy World
        </h1>
        <p>
        Welcome to Diy World – where handmade crochet meets heartfelt creativity.
We create charming hair accessories, cozy woolen bouquets, and unique décor for your kitchen and plant pots. Each item is crafted with care, bringing comfort, color, and character to your everyday spaces. At Wooly World, we turn yarn into something truly special—just for you.


        </p>
        <Link to='/products' className='btn'>
          shop now
        </Link>
      </article>
      <article className='img-container'>
        <img src={heroBcg} alt='' className='main-img' />
        <img src={heroBcg2} alt='' className='accent-img' />
      </article>
    </Wrapper>
  );
};

export default Hero;
